import { useState, useEffect } from 'react';

// TODO: Consider setting up a Context for document/window listeners
// https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/

const useViewport = (): { viewportWidth: number, viewportHeight: number } => {
    const [initialWidth, initialHeight] = typeof window !== 'undefined' ?
        [window.innerWidth, window.innerHeight] :
        [0, 0]; // window is not available during ssr

    const [width, setWidth] = useState(initialWidth);
    const [height, setHeight] = useState(initialHeight);

    useEffect(() => {
        const handleWindowResize = (): void => {
            setWidth(window.innerWidth);
            // Set the height in state as well as the width
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleWindowResize);

        return () => window.removeEventListener('resize', handleWindowResize);
    }, []);

    // Return both the height and width
    return { viewportWidth: width, viewportHeight: height };
};

export default useViewport;